/**
* Component: attachmentDetailsReducer
* Description: Reducer for attachment details
*/

const initialState = [];

const attachmentDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_ATTACHMENT_DETAILS':
       return !action.payload ? state : [...state,action.payload];

    case 'REMOVE_ATTACHMENT_DETAILS':
      return [];

    case 'CLEAR_ATTACHMENT_DETAILS':
      return [];
    default:
      return state;
  }
};

export default attachmentDetailsReducer;
